import { ExpertSkillsDesktop } from '../../components/ExpertSkills/ExpertSkillsDesktop'
import { ExpertSkillsMobile } from '../../components/ExpertSkills/ExpertSkillsMobile'

import { useAuth } from '../../contexts/AuthContext'
import { Medias } from '../../enumns/medias'
import { useMediaQuery } from '../../hooks/useMediaQuery'

export const Skills = () => {
  const isTabletSize = useMediaQuery(`(min-width: ${Medias.MD}px)`)

  const { user } = useAuth()

  if (!user) return null

  return isTabletSize ? (
    <ExpertSkillsDesktop expertId={user?.id} />
  ) : (
    <ExpertSkillsMobile expertId={user?.id} />
  )
}
